module.exports = __webpack_public_path__ + "img/clipart-ruler-printable-1.8c3000d5.png";